import D2C_ServiceApp from './App'

class D2C_ServicePython extends D2C_ServiceApp {
  static objectType = 'serviceType'
  static active = true
  static order = 14
  static typeName = 'python'
  static typeTitle = 'Python'
  static color = '#ffee55'
  static methods = {
    ...D2C_ServiceApp.methods,
    scale: true,
  }
  static fields = {
    ...D2C_ServiceApp.fields,
    buildCommands: {
      ...D2C_ServiceApp.fields.buildCommands,
      default: 'pip install -r requirements.txt',
    },
    hosts: {
      ...D2C_ServiceApp.fields.hosts,
      selector: {
        default: ['node', 'node'],
      },
    },
    image: {
      ...D2C_ServiceApp.fields.image,
      default: 'python',
    },
    ports: {
      ...D2C_ServiceApp.fields.ports,
      default: [
        {protocol: 'TCP', value: 8000},
      ],
    },
    source: {
      ...D2C_ServiceApp.fields.source,
      example: 'https://github.com/d2cio/python-hello-world',
    },
    startCommand: {
      default: 'python server.py',
      label: 'Command to start',
      path: 'startCommand',
      required: false,
      syntaxis: 'shell',
      validate() {
        return null
      },
      creating: {},
      importing: {},
      updating: {},
    },
    version: {
      ...D2C_ServiceApp.fields.version,
      default: '3.10',
      enum: ['2.7', '3.7', '3.8', '3.9', '3.10'],
    },
    volumes: {
      ...D2C_ServiceApp.fields.volumes,
      demo: [
        {src: '/ebs/containers/$serviceName/sources', dst: '/var/www/$serviceName', sync: false},
      ],
    },
  }
}

export default D2C_ServicePython
